import { Plugin } from "@ckeditor/ckeditor5-core";
import {
  ViewModel,
  addListToDropdown,
  createDropdown,
} from "@ckeditor/ckeditor5-ui";
import { Collection } from "@ckeditor/ckeditor5-utils";

import ViewTemplateIcon from "./view-dashboard-edit.svg";

// Templates are supplied by the React app via editor config
// (config.applyTemplate) and kept in sync through the cde:setApplyTemplates
// event. Each template is { id, label, type, contentAreas, html }; the editor
// only needs label (menu text) and html (content to apply). See CDE-17369.
export default class ApplyTemplateUI extends Plugin {
  init() {
    const editor = this.editor;

    this._definitions = new Collection();
    this.set("areTemplatesAvailable", false);
    this._setTemplates(editor.config.get("applyTemplate"));

    editor.ui.componentFactory.add("applyTemplate", (locale) => {
      const command = editor.commands.get("applyTemplate");
      const dropdown = createDropdown(locale);

      dropdown.buttonView.set({
        icon: ViewTemplateIcon,
        label: "Apply Template",
        tooltip: true,
      });

      // Disabled when the command is disabled (e.g. read-only) or when there are
      // no templates for the current Content Area (AC4).
      dropdown
        .bind("isEnabled")
        .to(
          command,
          "isEnabled",
          this,
          "areTemplatesAvailable",
          (isCommandEnabled, areTemplatesAvailable) =>
            isCommandEnabled && areTemplatesAvailable,
        );

      addListToDropdown(dropdown, this._definitions);

      dropdown.on("execute", (eventInfo) => {
        command.execute(eventInfo.source.html);
      });

      return dropdown;
    });

    editor.on("cde:setApplyTemplates", (_eventInfo, templates) => {
      this._setTemplates(templates);
    });
  }

  destroy() {
    this.editor.off("cde:setApplyTemplates");
    super.destroy();
  }

  _setTemplates(templates) {
    const list = Array.isArray(templates) ? templates : [];
    this._definitions.clear();
    list.forEach((template) => {
      this._definitions.add({
        type: "button",
        model: new ViewModel({
          label: template.label,
          withText: true,
          html: template.html,
        }),
      });
    });
    this.set("areTemplatesAvailable", this._definitions.length > 0);
  }
}
